import React from 'react';
import FormWrapper from './FormWrapper';

const FormSelect = function (props) {
  const {
    options, text, ...rest
  } = props;
  const { name } = props;
  const type = 'select';

  return (
    <FormWrapper name={name} text={text} type={type}>
      <select {...rest} onChange={() => { /* let event bubble */ }} >
        {Array.from(options).map(([key, value]) => <option value={key} key={key}>{value}</option>)}
      </select>
    </FormWrapper>
  );
};

export default FormSelect;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormSelect.js